import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function HeroSection() {
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20theater%20interior%20with%20glowing%20screen%2C%20empty%20red%20velvet%20seats%2C%20warm%20golden%20ambient%20lighting%2C%20atmospheric%20movie%20theater%20scene%2C%20professional%20cinematography%2C%20deep%20shadows%20and%20soft%20highlights%2C%20elegant%20composition&width=1800&height=900&seq=hero-bg-movie-site&orientation=landscape"
        alt="影院背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-4 leading-tight">
            精选高分佳作，告别片荒
          </h1>
          <p className="text-sm md:text-base text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
            每日更新精品推荐，全站高清画质流畅播放。从经典到热门，必看影视一网打尽。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-lg mx-auto">
            <div className="relative w-full sm:flex-1">
              <input
                type="text"
                placeholder="搜索你感兴趣的影片..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-3 rounded-lg bg-white/95 text-foreground-900 placeholder-foreground-400 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400 shadow-lg"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
            </div>
            <Link
              to="/category/all"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium whitespace-nowrap transition-colors shadow-lg cursor-pointer"
            >
              <i className="ri-search-line text-sm"></i>
              探索影片
            </Link>
          </div>

          <div className="mt-8 flex items-center justify-center gap-6 flex-wrap">
            {[
              { label: '10,000+', desc: '精选影片' },
              { label: '50+', desc: '影片分类' },
              { label: '每日', desc: '内容更新' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-white">
                  {stat.label}
                </div>
                <div className="text-xs text-white/60 mt-1">{stat.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}